import {
  type CreateQueryMediumRequest,
  type QueryMediumDetail,
  QueryMediumDetailSchema,
  type QueryMediumListQuery,
  type QueryMediumListResponse,
  QueryMediumListResponseSchema,
  type UpdateQueryMediumRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Query Medium master API. Every response is validated with the shared Zod
 * schema so a server change can't sneak past the UI types.
 */

export const listQueryMediums = async (
  query: QueryMediumListQuery,
): Promise<QueryMediumListResponse> => {
  const { data } = await apiClient.get<unknown>('/query-mediums', { params: query });
  return QueryMediumListResponseSchema.parse(data);
};

export const getQueryMedium = async (id: string): Promise<QueryMediumDetail> => {
  const { data } = await apiClient.get<unknown>(`/query-mediums/${id}`);
  return QueryMediumDetailSchema.parse(data);
};

export const createQueryMedium = async (
  payload: CreateQueryMediumRequest,
): Promise<QueryMediumDetail> => {
  const { data } = await apiClient.post<unknown>('/query-mediums', payload);
  return QueryMediumDetailSchema.parse(data);
};

export const updateQueryMedium = async (
  id: string,
  payload: UpdateQueryMediumRequest,
): Promise<QueryMediumDetail> => {
  const { data } = await apiClient.patch<unknown>(`/query-mediums/${id}`, payload);
  return QueryMediumDetailSchema.parse(data);
};

export const deleteQueryMedium = async (id: string): Promise<void> => {
  await apiClient.delete(`/query-mediums/${id}`);
};

export const bulkDeleteQueryMediums = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/query-mediums/bulk-delete', { ids });
  return data;
};

export const bulkSetQueryMediumsStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/query-mediums/bulk-set-status', { ids, isActive });
  return data;
};
